import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './install'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 2500,
        style: {
          background: '#0c2b20',          // ink green — matches the top bar
          color: '#f6f4ed',
          border: '1px solid rgba(255,255,255,0.1)',
          fontSize: '14px',
          fontWeight: 600,
          maxWidth: 420,
        },
        success: { iconTheme: { primary: '#c6f06a', secondary: '#0c2b20' } },
        error:   { iconTheme: { primary: '#fb7185', secondary: '#0c2b20' } },
      }}
    />
  </React.StrictMode>
)
